/**
 * Validação de env vars no boot. Falha cedo se algo estiver faltando.
 */
import { z } from 'zod'

const schema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  VITE_FIREBASE_MEASUREMENT_ID: z.string().optional().default(''),
  VITE_FIREBASE_TENANT_ID: z.string().min(1),
  VITE_OWNER_EMAIL: z.string().optional().default(''),
  VITE_HOSTING_SITE: z.string().min(1),
  VITE_USE_EMULATORS: z
    .union([z.literal('true'), z.literal('false')])
    .default('false')
    .transform((v) => v === 'true'),
})

const parsed = schema.safeParse(import.meta.env)

if (!parsed.success) {
  console.error('❌ Env vars inválidas:', parsed.error.flatten().fieldErrors)
  throw new Error('Env vars inválidas — veja console.')
}

export const env = parsed.data
